/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */

import { gql } from '@apollo/client'

export const PRODUCT_FRAGMENT = gql`
  fragment Product on Product {
    id
    name
    preferredName
    packagingName
    upcA
    planogramImageUrl
    marketingImageUrl
    packaging {
      quantity
      size
      unit
    }
  }
`
